import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');
    
    console.log("Auth callback received:", { 
      hasToken: !!token, 
      error,
      params: Object.fromEntries(searchParams.entries())
    });
    
    if (error) {
      console.error("Auth error:", error);
      setError(error);
      // Wait a bit before redirecting to login
      setTimeout(() => navigate('/login'), 3000);
      return;
    }
    
    if (token) {
      console.log("Token received from redirect");
      login(token).then(() => {
        console.log("Login successful, navigating to dashboard");
      }).catch(err => {
        console.error("Login failed:", err);
        setError("Authentication failed. Please try again.");
        // Wait a bit before redirecting to login
        setTimeout(() => navigate('/login'), 3000);
      });
    } else {
      console.error("No token received in callback");
      setError("No authentication token received. Please try again.");
      // Wait a bit before redirecting to login
      setTimeout(() => navigate('/login'), 3000);
    }
  }, [login, navigate, searchParams]);
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-4">
      {error ? (
        <div className="text-red-500 mb-4 text-center">
          <p className="text-xl font-semibold">Authentication Error</p>
          <p>{error}</p>
          <p className="mt-2 text-sm">Redirecting to login...</p>
        </div>
      ) : (
        <>
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-t-primary border-r-primary border-b-transparent border-l-transparent mb-4"></div>
          <p className="text-navy font-medium">Authenticating, please wait...</p>
        </>
      )}
    </div>
  );
}